import { apiResourceUrl } from "@ploy-lib/core";
import { BaseCamelCasedResource } from "@ploy-lib/rest-resources";
export class PriceOverviewResource extends BaseCamelCasedResource {
    pk() {
        return "singleton";
    }
    static url(urlParams) {
        return this.listUrl(urlParams);
    }
    static getEndpointExtra() {
        return {
            ...super.getEndpointExtra(),
            dataExpiryLength: 0
            // invalidIfStale: true
        };
    }
}
PriceOverviewResource.urlRoot = apiResourceUrl("priceOverview");
//# sourceMappingURL=PriceOverviewResource.js.map